import { ProgrammeType as r } from "../../../api/models/loyalty/loyaltyProgramme/loyaltyProgrammeConfiguration/loyaltyProgrammeSettings/programmeSettingsTypes.js";
import { LoyaltyProgressType as o } from "./LoyaltyProgress.js";
var e;
((m) => {
  function p(s) {
    return {
      [r.STAMP]: o.STAMP,
      [r.POINT]: o.BAR,
      [r.NONE]: o.NONE
    }[s];
  }
  m.programmeTypeToProgress = p;
})(e || (e = {}));
export {
  e as LoyaltyProgressUtils
};
//# sourceMappingURL=utils.js.map
